export default __webpack_public_path__ + "static/media/c006-a.dea36512.jpg";